export default [
  {
    path: 'printing/task',
    name: 'PrintingTask',
    component: () => import('@/views/Printing/Task.vue'),
    props: true,
    meta: {
      name: 'printing-task',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'tasks',
    name: 'tasks',
    component: () => import('@/views/Task/Index.vue'),
    props: true,
    meta: {
      name: 'tasks',
      has_auth: true,
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'task-content/:taskId',
    name: 'taskContent',
    component: () => import('@/views/Task/Show.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'task-create',
    name: 'taskCreate',
    component: () => import('@/views/Task/Create.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'task-update/:taskId',
    name: 'taskUpdate',
    component: () => import('@/views/Task/Update.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'print-task',
    name: 'printTask',
    component: () => import('@/views/Printing/Task.vue'),
    props: true,
    meta: {
      name: 'printing-task',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'task-factory-template-create',
    name: 'taskFactoryTemplateCreate',
    component: () => import('@/views/Task/Template/Create.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'task-template-content/:id',
    name: 'taskTemplateContent',
    component: () => import('@/views/Task/Template/Show.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: 'task-template-update/:id',
    name: 'taskTemplateUpdate',
    component: () => import('@/views/Task/Template/Update.vue'),
    props: true,
    meta: {
      name: 'tasks',
      middleware: 'auth',
      template: 'auth',
    },
  },
];
